import $ from 'jquery';

/**
 * The left panel is using fixed positioning to stay in the same position vertically, but we need it to act as
 * if it were absolute positioned horizontally.  When we enable the scrollable container, we also need it to adjust its
 * top and bottom so to not overlap the header or footer while you scroll the screen.  Unfortunately there is no
 * css only fix for either issue, so we need a bit of javascript to handle them.
 */
let $window = $(window); // Cached this so we don't need to wrap jquery over window every time we scroll
let $doc = $(document);
// Space in pixels that the container will leave between the container's top and the header/top of window, and the container's bottom with the
// footer/bottom of window
const DEFAULT_SPACING = 25;
let headerHeight = null;
let footerHeight = null;

const HALF_SECOND = 500;

export default function makeSticky(
    $container,
    onUpdate,
    namespace = 'leftPanel',
    spacing = DEFAULT_SPACING,
    useOnlyUpperHeader
) {
    let $stickyContainer = $($container);
    let scrollLeft = $window.scrollLeft();
    let scrollTop = $window.scrollTop();
    let windowHeight = $window.height();
    let docHeight = $doc.height();

    function getHeaderHeight() {
        if (useOnlyUpperHeader) {
            return $('.app-header__top-bar').outerHeight();
        }
        return $('.app-header').outerHeight();
    }

    headerHeight = getHeaderHeight();
    footerHeight = $('#footer').outerHeight();

    function updateScrollLeft() {
        var newScrollLeft = $window.scrollLeft();

        // We need to exclude 2 scenarios:
        //   1. The horizontal scroll didn't change (it would just be a performance loss to run this on vertical scroll also)
        //   2. The horizontal scroll is negative (could happen on OSX laptops especially)
        if (newScrollLeft !== scrollLeft && newScrollLeft >= 0) {
            scrollLeft = newScrollLeft;

            // Move the container according to the scroll
            $stickyContainer.css('margin-left', -scrollLeft);
        }
    }

    function calculateContainerTop() {
        var newTop = headerHeight - scrollTop;
        return newTop > 0 ? newTop : 0;
    }

    function calculateContainerBottom() {
        var newBottom = footerHeight - (docHeight - (windowHeight + scrollTop));
        return newBottom > 0 ? newBottom : 0;
    }

    function updateContainerTop() {
        $stickyContainer.css('top', calculateContainerTop() + spacing + 'px');
    }

    function updateContainerBottom() {
        $stickyContainer.css('bottom', calculateContainerBottom() + spacing + 'px');
    }

    updateContainerTop();
    updateContainerBottom();
    onUpdate && onUpdate();

    $window.on(`scroll.${namespace}`, function () {
        updateScrollLeft();

        let newScrollTop = $window.scrollTop();
        if (newScrollTop !== scrollTop) {
            scrollTop = newScrollTop;
            updateContainerTop();
            updateContainerBottom();
            onUpdate && onUpdate();
        }
    });

    $window.on(`resize.${namespace}`, function () {
        windowHeight = $window.height();
        updateContainerBottom();
        onUpdate && onUpdate();
    });

    let docHeightIntervalId = setInterval(function () {
        var newDocHeight = $doc.height();
        if (newDocHeight !== docHeight) {
            docHeight = newDocHeight;
            updateContainerBottom();
            onUpdate && onUpdate();
        }
    }, HALF_SECOND);

    let initializeIntervalId;

    if (!headerHeight || !footerHeight) {
        initializeIntervalId = setInterval(function () {
            headerHeight = getHeaderHeight();
            footerHeight = $('#footer').outerHeight();
            if (headerHeight && footerHeight) {
                updateContainerTop();
                updateContainerBottom();
                clearInterval(initializeIntervalId);
            }
        }, HALF_SECOND);
    }

    return function () {
        $window.off(`.${namespace}`);
        clearInterval(docHeightIntervalId);
        clearInterval(initializeIntervalId);
    };
}
